import InvitePage from './InvitePage';
import StatementsRollbackWizard from './Wizard';

export { InvitePage as StatementsRollbackInvitePage };
export default StatementsRollbackWizard;
